export default "__VITE_ASSET__yEncD90b__"